module.exports = __webpack_public_path__ + "img/5p.d166c27b.png";